define('views/content/resellers',['require','views/base/list_page_view','views/components/reseller/resellers','collections/resellers','text!templates/content/resellers.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ResellersView = require('views/components/reseller/resellers');
    var ResellersCollection = require('collections/resellers');

    var temp = require("text!templates/content/resellers.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-page',
        titleKey: 'resellers',

        setCollection: function () {
            this.collection = new ResellersCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ResellersView({
                collection: this.collection
            }));
        }

    });
});
